<template>
  <div
    class="app-layout"
    :style="{
      '--layout-offset-top': !sticky ? '0px' : undefined,
      '--launch-banner-height': !displayNewsBanner ? '0px' : undefined,
    }"
  >
    <div
      class="-top-(--top-header-height) sticky z-50 w-full transition-all duration-300"
      :class="{ '!top-0': sticky }"
    >
      <news-banner
        v-if="!noNavigation && displayNewsBanner && currentNews"
        class="h-(--launch-banner-height) w-full"
        :news="currentNews"
        @close="acknowledgeNewsBanner"
      />

      <main-header
        class="h-(--top-nav-height)"
        :class="{
          '!bg-white': sticky,
          'bg-primary-50': transparentHeader,
          shadow: sticky && !route.path.startsWith('/catalog'),
        }"
        :no-navigation="noNavigation"
        :transparent="transparentHeader && !sticky"
      />
    </div>

    <main class="min-h-screen" data-cy-main-content>
      <slot />
    </main>

    <faq-section v-if="!noFaq" class="py-16 md:py-32" />

    <main-footer v-if="!noFooter" :hide-qualiopi="hideQualiopiFooter" />
  </div>
</template>

<script setup lang="ts">
import FaqSection from "~/layouts/_includes/components/faq-section.vue";
import MainHeader from "~/layouts/_includes/components/main-header.vue";
import MainFooter from "~/layouts/_includes/main-footer.vue";
import NewsBanner from "~/layouts/_includes/news-banner.vue";

const sticky = ref(false);

if (import.meta.client) {
  const { directions, y } = useScroll(document);

  watchEffect(() => {
    if (
      directions.bottom ||
      y.value === 0 ||
      route.meta.stickyHeader === false
    ) {
      sticky.value = false;
    } else if (directions.top) {
      sticky.value = true;
    }
  });
}

const route = useRoute();
const noFooter = computed(() => Boolean(route.meta.noFooter));
const noNavigation = computed(() => Boolean(route.meta.noNavigation));
const noFaq = computed(() => Boolean(route.meta.noFaq));
const transparentHeader = computed(() => Boolean(route.meta.transparentHeader));
const hideQualiopiFooter = computed(() =>
  Boolean(route.meta.hideQualiopiFooter),
);

const { acknowledgeNewsBanner, displayNewsBanner, currentNews } =
  useNewsBanner();
</script>

<style scoped>
@reference "~/assets/tailwind.css";

.app-layout {
  --top-nav-height: 60px;
  --launch-banner-height: 100px;
  --top-header-height: calc(
    var(--top-nav-height) + var(--launch-banner-height)
  );
  --layout-offset-top: var(--top-header-height);
}

@media (min-width: theme("--breakpoint-desktop-nav")) {
  .app-layout {
    --top-nav-height: 80px;
  }
}

@media (min-width: theme("--breakpoint-md")) {
  .app-layout {
    --launch-banner-height: 60px;
  }
}
</style>
